import React from 'react'
import SocialMedia from '../components/SocialMedia';
import Navigation from '../components/Navigation';

const AppWrap = (Component, idName, classNames) => {
    // AppWrap returns a function
    return function HOC(){
        return(
            <div id={idName} className={`app__container ${classNames}`}>
            {/* width: 100, display: flex, flexdirection row --, min height 100vh */}
                <SocialMedia />
                <div className="app__wrapper app_flex">
                {/* flex, align/justify: center, flex 1 direction column | */}
                    <Component />
                </div>
                <Navigation/>
            </div>
        )
    }
}
export default AppWrap